import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StackBlock } from '@yonderland/andes-react';
import { UnavailableProductsMessage } from './UnavailableProductsMessage';
import { ApplePayMessage } from './ApplePayMessage';
import { BasketMergedMessage } from './BasketMergedMessage';
import { PaybackVoucherMessage } from './PaybackVoucherMessage';
import { BuyAndGetMessages } from './BuyAndGetMessages';
import { DynamicMessage } from './DynamicMessage';
import { PromotionMessage } from './PromotionMessage';
export const BasketOverviewMessages = () => (_jsxs(StackBlock, { gap: "6", children: [_jsx(UnavailableProductsMessage, {}), _jsx(ApplePayMessage, {}), _jsx(BasketMergedMessage, {}), _jsx(PaybackVoucherMessage, {}), _jsx(BuyAndGetMessages, {}), _jsx(DynamicMessage, {}), _jsx(PromotionMessage, {})] }));
